var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 2.4H4C3.1 2.4 2.4 3.125 2.4 4V10.4C2.375 11.3 3.1 12 4 12H9.65C9.875 12 10.075 11.925 10.225 11.775L11.75 10.25C11.9 10.1 12 9.9 12 9.675V4C12 3.125 11.275 2.4 10.4 2.4ZM10.8 8.8H9.575C9.15 8.8 8.775 9.175 8.775 9.6L8.8 10.8H4C3.775 10.8 3.6 10.625 3.6 10.4V4C3.6 3.8 3.775 3.6 4 3.6H10.4C10.6 3.6 10.8 3.8 10.8 4V8.8ZM0 9V3C0 1.35 1.325 0 3 0H9C9.325 0 9.6 0.275 9.6 0.6C9.6 0.95 9.325 1.2 9 1.2H3C2 1.2 1.2 2.025 1.2 3V9C1.2 9.35 0.925 9.6 0.6 9.6C0.25 9.6 0 9.35 0 9Z",
    fill: "#007BC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.9966725fc5bc41d4fd6ca1a7e1e8bd24.svg";
export { ForwardRef as ReactComponent };